module.exports = __webpack_public_path__ + "static/img/6.e3649afa.jpg";